import React, { useState } from "react";
import { Button, Form, Popup } from "semantic-ui-react";
import { useMutation, gql } from "@apollo/client";
import Swal from "sweetalert2";
const CreateModule = ({ reload }) => {
  const [name, setName] = useState("");

  const onCompleted = async () => {
    setName("");
    await reload();

    Swal.fire({
      icon: 'success',
      title: 'Completado',
      text: 'Se ha creado el módulo de manera exitosa.'
    })
  };

  const onError = ({ graphQLErrors }) => {
    if (graphQLErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: graphQLErrors[0]?.message
      });
    } else {
      Swal.fire("Lo sentimos, ha ocurrido un error.");
    }
  };

  const [mutation] = useMutation(CREATE_MODULE, { onCompleted, onError });
  const handleMutation = () => {
    mutation({
      variables: {
        nombre: name
      }
    })
  };
  return (
    <Popup
      on='click'
      trigger={<Form.Button content='Agregar modulo' icon='add' />}
      wide>
      <Form>
        <Form.Input
          value={name}
          onChange={(e, { value }) => setName(value)}
          placeholder="Nombre" />
        <Button onClick={handleMutation} disabled={!name.trim()}>Guardar</Button>
      </Form>
    </Popup>
  );
};


const CREATE_MODULE = gql`
  mutation createModule($nombre: String!, $estado: Status) {
    crearMultiModulo(nombre: $nombre, estado: $estado) {
      id
      nombre
      estado
    }
  }
`;


export default CreateModule;